module.exports = __webpack_public_path__ + "img/header-weddingRingsPlatinum@2x.6f778eb.webp";